import { useAtomValue, useSetAtom } from 'jotai';
import {
  formDataAtom,
  formErrorAtom,
  handleFormErrorAtom,
  handleFormDataUpdateAtom,
} from './atoms';

export const useFormData = () => {
  const formData = useAtomValue(formDataAtom);
  const formError = useAtomValue(formErrorAtom);
  const updateFormData = useSetAtom(handleFormDataUpdateAtom);
  const handleFormError = useSetAtom(handleFormErrorAtom);

  return {
    formData,
    formError,
    updateFormData,
    handleFormError,
  };
};
